export const getApiBaseUrl = (): string => {
  switch (process.env.REACT_APP_STAGE) {
    case 'local':
      return `http://localhost:3000`;
    case 'dev':
      return `https://api-dev.pixels.ai`;
    default:
      return `https://api.pixels.ai`;
  }
};

export const getAssetsBaseUrl = (): string => {
  switch (process.env.REACT_APP_ASSET_STAGE) {
    case 'dev':
      return `https://assets-dev.pixels.ai`;
    default:
      return `https://assets.pixels.ai`;
  }
};
